<button matSuffix mat-icon-button (click)="showDialog()">
  <mat-icon>help</mat-icon>
</button>
